export default {
  name: 'EcsEndPointSelectionMixin',

  mixins: [],

  methods: {
    convertEndpointToEcsFormat(endpoint) {
      const terminal = {
        terminalURI: endpoint.destination
      };

      switch (endpoint.type) {
        case 'HPBXPhone':
          terminal.terminalType = 'HPBX';
          break;
        case 'PrivatePhone':
          terminal.terminalType = 'Private';
          break;
        case 'InternalPhone':
          terminal.terminalType = 'InternalPhone';
          terminal.useInternalPhone = true;
          break;
        case 'Custom':
          terminal.terminalType = 'Other';
          break;
        default:
          throw new Error('Invalid endpoint type');
      }

      return terminal;
    }
  }
};
